import { authenticate } from '@cian/auth/lib/authenticator';
import { IHttpApi } from '@cian/http-api/shared';

import {
  fetchSubscriptionSendContract,
  ISubscriptionSendContractRequest,
  ISubscriptionSendContractResponseError,
  TSubscriptionSendContractResponse,
} from '../../repositories/monolith-python/v1/subscription-send-contract';
import { IContractRentSaleResponse } from '../../store/contract_rent_sale';

export async function subscriptionContractRentSale(
  httpApi: IHttpApi,
  parameters: ISubscriptionSendContractRequest,
): Promise<IContractRentSaleResponse | ISubscriptionSendContractResponseError> {
  const responseData: TSubscriptionSendContractResponse = await fetchSubscriptionSendContract({
    httpApi,
    parameters,
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
        withCredentials: false,
      },
    },
  });

  if (responseData.statusCode === 400) {
    throw responseData.response;
  }

  const { response, statusCode } = responseData;
  const { logOnInfo = undefined, login = undefined } = 'data' in response ? response.data : {};
  const subscribe = statusCode === 204;

  if (logOnInfo && login) {
    return authenticate(logOnInfo, login, true).then(
      (): IContractRentSaleResponse => ({
        auth: true,
        subscribe,
        user: {
          email: login,
          isAuthenticated: true,
          cianName: null,
          cianUserId: null,
          companyName: '',
          criteoEmail: null,
          firstName: null,
          ga: null,
          isAgent: null,
          lastName: null,
          permissions: null,
          phones: null,
          realtyUserId: null,
        },
      }),
    );
  } else {
    return {
      auth: false,
      subscribe,
    };
  }
}
